import { differenceInMonths, differenceInYears } from "date-fns";

export const getAgeFromDate = (fromDate?: Date): number | undefined => {
  if (!fromDate) {
    return undefined;
  }
  return differenceInYears(new Date(), fromDate);
};

export const ageInMonthsFromDate = (fromDate?: Date): number | undefined => {
  if (!fromDate) {
    return undefined;
  }
  return differenceInMonths(new Date(), fromDate) + 1;
};
